"use client";

import { YMInitializer } from "react-yandex-metrika";
import { usePathname } from "next/navigation";
import { useEffect } from "react";
import ym from "react-yandex-metrika";

const YM_COUNTER_ID = 54994984;

export default function YandexMetrika() {
  const pathname = usePathname();

  useEffect(() => {
    if (pathname) {
      ym("hit", pathname);
    }
  }, [pathname]);

  return (
    <YMInitializer
      accounts={[YM_COUNTER_ID]}
      options={{
        clickmap: true,
        trackLinks: true,
        accurateTrackBounce: true,
        webvisor: true,
      }}
      version="2"
    />
  );
}
